// extracted by mini-css-extract-plugin
export var standaloneTable = "_go-0";
export var withExtraHeader = "_go-1";